import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, inject, input, output } from '@angular/core';
import type User from "../../../auth/models/user.modes";
import type {SideBarMode} from "../navigation-constants";
import {navigation, navigationAdmin} from "../navigation-constants";
import type NavigationMenu from "../navigation.model";
import {AuthService} from "../../../auth/auth.service";
import {environment} from "../../../../environments/environment";
import {filter, takeUntil} from "rxjs/operators";
import {NavigationEnd, Router} from "@angular/router";
import {isUrlInChildren} from "../../../utilities/route";
import {from, fromEvent, Subscription} from "rxjs";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);
  private cdr = inject(ChangeDetectorRef);
  private authService = inject(AuthService);
  private router = inject(Router);


  readonly user = input<User>(undefined);
  readonly mode = output<'closed' | 'opened' | 'hovered'>();
  readonly menuItemClicked = output();

  subs = new Subscription();

  navigation: NavigationMenu [];
  opened = true;
  isAdmin;

  private readonly localStorageItem = 'sideBarState';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  mouseEnterFunc = () => {
    this.el.nativeElement.classList.toggle('folded');
    this.mode.emit('hovered');
  }
  mouseLeaveFunc = () => {
    this.el.nativeElement.classList.toggle('folded');
    this.mode.emit('closed')
  };

  ngOnInit(): void {
    this.navigation = navigation;
    this.isAdmin = this.authService.loggedUser.getValue().isAdmin;
    if(this.isAdmin) {
      this.navigation[0].children.push(...navigationAdmin);
    }
    /*const item = localStorage.getItem(this.localStorageItem);
    if(item === "false")
      this.toggleSidebar();*/

    this.subs.add(this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if(isUrlInChildren(this.navigation[0], event.urlAfterRedirects))
          this.menuItemClicked.emit();
      }));

    this.subs.add(fromEvent(window, 'resize').subscribe(() => this.menuItemClicked.emit()));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    if(this.isAdmin) {
      this.navigation[0].children.splice(-2);
    }
  }

  toggleSidebar() {
    this.opened = !this.opened;
    if(this.opened) {
      this.el.nativeElement.removeEventListener('mouseenter', this.mouseEnterFunc);
      this.el.nativeElement.removeEventListener('mouseleave', this.mouseLeaveFunc);
      this.mode.emit('opened');
    }
    if(!this.opened) {

      setTimeout(() => {
        this.el.nativeElement.addEventListener('mouseenter', this.mouseEnterFunc);
        this.el.nativeElement.addEventListener('mouseleave', this.mouseLeaveFunc);
      }, 300)
      this.el.nativeElement.classList.toggle('folded');
      this.mode.emit('closed');
    }
    this.cdr.markForCheck();
    localStorage.setItem(this.localStorageItem, this.opened + '')
  }


}
